import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import i18n from 'live/services/i18n'

import { reducer } from './reducer'
// import { Chart } from './Chart'
import Chart from './widget'
import Config from './config/Input/index'
import './logo.scss'

export default widgetService.register({
    type: 'solid-gauge',
    get name() {
        return i18n('Solid Gauge')
    },
    get description() {
        return ''
    },
    config: {
        value: '',
        valueColor: '',
        targetColor: '',
        target: '',
        title: '',
        stopsColor1: '',
        stopsColor2: '',
        stopsColor3: '',
        stopsValue1: '',
        stopsValue2: '',
        stopsValue3: '',
        unit: '',
        extremeUnity: true,
        usingRange: false,
        showDivider: false,
        gradient: true
        // combineColors: true
    },
    //@ts-ignore
    ui: { configForm: Config },
    policies: {
        baselineCapacity: false,
        output: 'snapshot',
        currentCrosshairValueCapacity: false
    },
    impl: reactWidgetWrapper<ChartState, ChartMessage>(Chart, reducer)
})
